import  store  from './../../store';

class DAODefaultDiamond {
	getList(country, carat, currentStone = 124705) {
		return new Promise((resolve) => {
			let url = store.getters["config/getDiamondStockUrl"] + "/Designer/getData.php";

			switch(carat) {
				case 0.4: currentStone	= 124706;
					break;
				case 0.5: currentStone	= 124707;
					break;
				case 0.7: currentStone	= 124708;
					break;
				case 1.0: currentStone	= 124709;
					break;
				case 1.5: currentStone	= 124710;
					break;
				case 2.0: currentStone	= 124711;
					break;
			}

			fetch(
				url + '?ac=getDefaultStones&currentStone=' + currentStone + '&caratSize=' + carat.toString() + '&code=' + country,
				{}
			).then(response => {
				response.json().then(json => {
					const defaultDiamond = {
						'list': [],
						'search': {
							'carat': []
						}
					};

					if (typeof json.vars.stone.stone.criteria_list == 'object') {
						defaultDiamond.list = json.vars.stone.stone.criteria_list;
					}

					if (typeof json.vars.stone.stone.size_list == 'object') {
						defaultDiamond.search.carat = json.vars.stone.stone.size_list;
					}

					resolve(defaultDiamond);
				});
			})
		});
	}


	/**
	 *
	 * @param qualityId Get Color And Purity By Quality Id
	 * @returns {*|boolean}
	 */
	getColorAndPurityByQualityId(qualityId) {
		let qualityMapping = {
			"1": {
				"colorId": 7,
				"purityId": 1,
			},
			"2": {
				"colorId": 7,
				"purityId": 3,
			},
			"3": {
				"colorId": 6,
				"purityId": 7,
			},
			"4": {
				"colorId": 7,
				"purityId": 7,
			},
			"5": {
				"colorId": 9,
				"purityId": 7,
			},
			"7": {
				"colorId": 2,
				"purityId": 1,
			},
			"8": {
				"colorId": 2,
				"purityId": 7,
			},
			"9": {
				"colorId": 6,
				"purityId": 1,
			},
			"27": {
				"colorId": 6,
				"purityId": 3,
			},
			"31": {
				"colorId": 2,
				"purityId": 11,
			},
			"41": {
				"colorId": 10,
				"purityId": 7,
			},
		};

		if (qualityId in qualityMapping) {
			return qualityMapping[qualityId];
		} else {
			return false;
		}
	}
}

export default new DAODefaultDiamond();
